<template>
  <div
    ref="wm1"
    class="wheel"
    :style="{ top: currentX + '%', left: currentY + '%' }"
  >
    <svg class="w1" :width="sizeAndStroke" :height="sizeAndStroke">
      <circle
        class="one"
        :cx="halfSizeHalfStroke"
        :cy="halfSizeHalfStroke"
        :r="size / 2"
        :opacity="op1"
        :stroke="randomColor[0]"
        :stroke-width="stroke"
        :style="computedTransformOrigin"
      >
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0"
          to="360"
          begin="0"
          repeatCount="indefinite"
          :dur="dur"
        />
      </circle>

      <circle
        class="two"
        :cx="halfSizeHalfStroke"
        :cy="halfSizeHalfStroke"
        :r="size / 2"
        :opacity="op2"
        :stroke="randomColor[1]"
        :stroke-width="stroke"
        :style="computedTransformOrigin"
      >
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="360"
          to="0"
          begin="0"
          :dur="dur"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  </div>
</template>

<script>
export default {
  data () {
    return {
      x: 10, y: 10, size: 30, stroke: 8, dur: 20, op1: .1, op2: .1,
      path: {
        x1: 50, y1: 500,
        x2: 200, y2: 700,
        x3: 10, y3: 1500,
        x4: 280, y4: 2000,
      },
      colors: ["#0014ff", "#3a48e8", "#0e1aab", "#0357ff", "#1ab6eb", "#177fbf", "#0048ff", "#4c00ff", "#6f00ff", "#4c00ff"]
    }
  },
  computed: {
    currentX () {
      return this.x
    },
    currentY () {
      return this.y
    },
    sizeAndStroke () {
      var totalSize = parseInt(this.size) + parseInt(this.stroke)
      return totalSize
    },
    halfSizeHalfStroke () {
      return this.size / 2 + this.stroke / 2
    },
    computedTransformOrigin () {
      var dimensions = this.halfSizeHalfStroke + 'px ' + this.halfSizeHalfStroke + 'px'
      return { 'transform-origin': dimensions }
    },
    locationStyle () {
      return { top: this.currentX + 'px', left: this.currentY + 'px' }
    },
    randomColor () {
      var randomIndex1 = Math.floor(Math.random() * (this.colors.length - 0))
      var randomIndex2 = Math.floor(Math.random() * (this.colors.length - 0))
      var twoRandomColors = [this.colors[randomIndex1], this.colors[randomIndex2]]
      return twoRandomColors
    }
  },
  mounted () {
    this.gsap.to(this.$refs.wm1, {
      x: this.path.x1, y: this.path.y1,
      duration: 1,
      ease: "expo",
    });

    this.gsap.fromTo(this.$refs.wm1, {
      x: this.path.x1, y: this.path.y1,
    }, {
      scrollTrigger: {
        trigger: '.box2',
        start: '7% 25%',
        end: '+=75%',
        scrub: 0.5,
        pin: true,
        // markers: true,
        toggleActions: 'restart pause reverse pause'
      },
      x: this.path.x2, y: this.path.y2,
      duration: .5
    })

    this.gsap.fromTo(this.$refs.wm1, {
      x: this.path.x2, y: this.path.y2,
    }, {
      scrollTrigger: {
        trigger: '.box2',
        start: '34% 25%',
        end: '+=80%',
        scrub: 0.5,
        pin: true,
        // markers: true,
        toggleActions: 'restart pause reverse pause'
      },
      x: this.path.x3, y: this.path.y3,
      duration: 1
    })

    this.gsap.fromTo(this.$refs.wm1, {
      x: this.path.x3, y: this.path.y3,
    }, {
      scrollTrigger: {
        trigger: '.box2',
        start: '60% 25%',
        end: '+=80%',
        scrub: 0.5,
        pin: true,
        // markers: true,
        toggleActions: 'restart pause reverse pause'
      },
      x: this.path.x4, y: this.path.y4,
      duration: 3
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mixin.scss";

.wheel {
  position: absolute;

  svg.w1 {
    fill: none;

    .one {
      stroke-dasharray: 80 30 50;
    }

    .two {
      stroke-dasharray: 40 10 20 30;
    }
  }
}
</style>